var _defs, _path, _path2, _path3, _path4, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 882.62 182.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:url(#Nepojmenovan\xFD_p\u0159echod_3);}.cls-4{fill:url(#Nepojmenovan\xFD_p\u0159echod_2);}.cls-5{clip-path:url(#clippath-1);}.cls-6{clip-path:url(#clippath-2);}.cls-7{fill:url(#Nepojmenovan\xFD_p\u0159echod);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m156.04,44.34h33.88c2.58,0,4.68,2.1,4.68,4.68v125.07c0,2.58-2.1,4.68-4.68,4.68h-33.88c-2.58,0-4.68-2.1-4.68-4.68V49.02c0-2.58,2.1-4.68,4.68-4.68Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nepojmenovan\\xFD_p\\u0159echod",
    x1: -167.49,
    y1: 470.26,
    x2: -166.49,
    y2: 470.26,
    gradientTransform: "translate(16426.9 45936.4) scale(97.45 -97.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b02de9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#b02de9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#6d00cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d00cc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.66,45.99L.5,157.74c-1.16,2.31-.23,5.12,2.08,6.28l30.27,15.21c2.31,1.16,5.12.23,6.28-2.08l56.16-111.75c1.16-2.31.23-5.12-2.08-6.28l-30.27-15.21c-.68-.34-1.39-.5-2.1-.5-1.71,0-3.36.94-4.18,2.58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nepojmenovan\\xFD_p\\u0159echod_2",
    x1: -167.49,
    y1: 470.26,
    x2: -166.49,
    y2: 470.26,
    gradientTransform: "translate(17962.6 50466.15) scale(107.08 -107.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#e90cf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#c023ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#b02de9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b02de9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m103.9,46.39l-24.03,121.81c-.5,2.53,1.14,4.98,3.67,5.49l33.21,6.7c2.54.51,5.02-1.14,5.52-3.68l24.03-121.81c.5-2.53-1.14-4.98-3.67-5.49l-33.21-6.7c-.31-.06-.62-.09-.93-.09-2.19,0-4.15,1.54-4.59,3.77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nepojmenovan\\xFD_p\\u0159echod_3",
    x1: -167.49,
    y1: 470.26,
    x2: -166.49,
    y2: 470.26,
    gradientTransform: "translate(35959.81 101077.55) scale(214.7 -214.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#e90cf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#c023ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#b02de9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a42be3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#8626d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#6021c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6021c3"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m302.28,94.98v79.5c0,2.58-2.1,4.68-4.68,4.68h-34.35c-2.59,0-4.68-2.1-4.68-4.68V48.94c0-2.58,2.1-4.68,4.68-4.68h34.35c2.58,0,4.68,2.1,4.68,4.68v9.89c8.63-10.79,20.77-17.54,37.77-17.54,15.92,0,29.68,6.48,38.04,18.62,10.25-12.14,24.82-18.62,42.63-18.62,30.22,0,50.99,17.81,50.99,51.8v81.39c0,2.58-2.1,4.68-4.68,4.68h-34.35c-2.59,0-4.68-2.1-4.68-4.68v-72.21c0-14.84-8.36-22.12-19.7-22.12-9.44,0-17,5.94-21.32,14.84v79.5c0,2.58-2.1,4.68-4.68,4.68h-34.35c-2.59,0-4.68-2.1-4.68-4.68v-72.21c0-14.84-8.36-22.12-19.7-22.12-9.71,0-17,5.94-21.32,14.84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m529.16,181.86c-25.36,0-46.68-16.73-46.68-42.63,0-23.74,15.65-34.81,44.79-42.36l37.24-9.71c-1.08-8.9-8.1-13.22-19.43-13.22-10.04,0-17.26,3.84-20.59,11.52-.93,2.14-3.16,3.4-5.44,2.86l-29.51-7.02c-2.72-.65-4.31-3.55-3.34-6.17,8.47-22.92,32.01-34.93,60.49-34.93,38.31,0,60.44,18.08,60.44,49.91v84.36c0,2.59-2.1,4.68-4.68,4.68h-32.57c-2.54,0-4.62-2.03-4.68-4.57l-.16-7.03-.27.27c-11.06,9.44-21.85,14.03-35.62,14.03m11.06-33.73c5.67,0,9.98-1.62,16.46-5.4l7.55-4.59.27-21.86-19.43,5.4c-13.22,3.78-19.16,7.02-19.16,14.57,0,8.36,7.28,11.87,14.3,11.87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m676.92,115.49l-13.22,12.14v46.85c0,2.59-2.1,4.68-4.68,4.68h-33.54c-2.59,0-4.68-2.1-4.68-4.68V4.68c0-2.58,2.1-4.68,4.68-4.68h33.54c2.58,0,4.68,2.1,4.68,4.68v76.81l39.13-36c.86-.79,2-1.24,3.17-1.24h41.41c4.28,0,6.31,5.26,3.16,8.14l-40.18,36.65,45.82,83.18c1.72,3.12-.54,6.94-4.1,6.94h-39.15c-1.74,0-3.35-.97-4.15-2.52l-31.88-61.16Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m819.25,182.13c-37.5,0-71.77-23.47-71.77-70.96,0-44.79,32.92-70.69,69.07-70.69s64.76,26.17,65.83,67.45c.12,4.36.19,7.4.23,9.56.04,2.62-2.07,4.74-4.68,4.74h-87.28c1.35,16.19,14.3,26.44,30.76,26.44,11.71,0,21.31-4.87,28.04-13.67,1.49-1.95,4.24-2.4,6.28-1.03l21.8,14.6c2.18,1.46,2.72,4.42,1.25,6.59-11.68,17.19-30.94,26.97-59.52,26.97m-27.79-86.34h47.22c-.27-15.38-11.6-22.12-23.47-22.12-11.06,0-22.39,6.48-23.74,22.12"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 129.45,
    y: 41.01,
    width: 87.08,
    height: 141.09,
    transform: "translate(-27.91 66.73) rotate(-20.24)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -23.86,
    y: 29.77,
    width: 143.51,
    height: 164.28,
    transform: "translate(-40.48 28.2) rotate(-23.38)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 57.56,
    y: 35.23,
    width: 111.05,
    height: 153.08,
    transform: "translate(-31.65 45.95) rotate(-20.21)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMake);
export default __webpack_public_path__ + "static/media/make.9612228e6969ffa0cff73be6442878a9.svg";
export { ForwardRef as ReactComponent };